import { IReactChildrenOnly } from "@custom-types/types";
import { LocalizeProvider } from "@faro-lotv/foreign-observers";
import { runtimeConfig } from "@src/runtime-config";
import { useAppSelector } from "@store/store-helper";
import { devFeaturesStateSelector } from "@store/dev-features/dev-features-selector";
import { isNumberedDevEnvironment } from "@utils/env-utils";
import { isLocalhost } from "@faro-lotv/foundation";
import { shouldEnableSaveNewPhrases } from "@utils/localize-utils";


/** The localization loader making it possible to implement language translation */
export function LocalizeLoader({ children }: IReactChildrenOnly): JSX.Element {
  const {isTranslationOverrideAllowed} = useAppSelector(devFeaturesStateSelector);
  const isNumberDevelopmentEnvironment = isNumberedDevEnvironment();

  const isSaveNewPhrasesEnabled = shouldEnableSaveNewPhrases({
    isNumberedDevEnvironment: isNumberDevelopmentEnvironment,
    isLocalhost: isLocalhost(),
    isTranslationOverrideAllowed,
  });

  return (
    <LocalizeProvider
      projectKey={runtimeConfig.features.localizeKey}
      initOptions={{
        // eslint-disable-next-line @typescript-eslint/naming-convention
        saveNewPhrases: isSaveNewPhrasesEnabled,
      }}
    >
      {children}
    </LocalizeProvider>
  );
}
